export const parseMd = (md = "") => {
  const blocks = [];
  const lines = md.replace(/\r/g, "").split("\n");
  let para = [];
  let list = null;
  let table = null;

  const flush = () => {
    if (para.length) {
      blocks.push({ type: "p", text: para.join(" ") });
      para = [];
    }
    if (list) {
      blocks.push({ type: "list", items: list });
      list = null;
    }
    if (table) {
      blocks.push({ type: "table", head: table.head, rows: table.rows });
      table = null;
    }
  };

  for (const raw of lines) {
    const line = raw.trim();
    if (!line) {
      flush();
      continue;
    }
    if (line.startsWith("### ")) {
      flush();
      blocks.push({ type: "h3", text: line.slice(4) });
      continue;
    }
    if (line.startsWith("## ")) {
      flush();
      blocks.push({ type: "h2", text: line.slice(3) });
      continue;
    }
    if (line.startsWith("- ")) {
      if (para.length || table) flush();
      list = list || [];
      list.push(line.slice(2));
      continue;
    }
    if (line.startsWith("|")) {
      if (para.length || list) flush();
      const cells = line
        .split("|")
        .slice(1, -1)
        .map((c) => c.trim());
      if (cells.every((c) => /^-{3,}$/.test(c))) continue;
      if (!table) table = { head: cells, rows: [] };
      else table.rows.push(cells);
      continue;
    }
    if (list || table) flush();
    para.push(line);
  }
  flush();
  return blocks;
};
